module.exports = __webpack_public_path__ + "img/CashierShiftSummary.47130ca8.jpg";